
export const API_URL = "https://osis-des.up.gov.in/api/";

// export const API_URL = "https://updesdemo-api.srmtechsol.com/";

// export const API_URL = "http://192.0.0.204:8014/";

// export const API_URL = "http://localhost:8013/";
 